'use client'

import { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import Typography from '@/components/Typography'
import styles from './styles.module.css'
import AnimatedSection from '@/components/AnimatedSection'
import Contact from '../_blocks/Main_redesign/Contact'
import useEmblaCarousel from 'embla-carousel-react'

const categories = ['Все', 'Промышленность', 'Финансы', 'Юридические услуги', 'Строительство', 'Ритейл', 'Другое']

const cases = [
	{
		id: 1,
		title: 'Автоматизация казначейства в финансовом секторе',
		description: 'Автоматизация процессов обработки трансграничных платежей',
		category: 'Финансы',
		image: '/images/portfolio/redesign/case_card_image_1.png'
	},
	{
		id: 2,
		title: 'Маркетплейс материалов',
		description: 'Платформа, объединяющая заказчиков и производителей материалов со всего мира',
		category: 'Ритейл',
		image: '/images/portfolio/redesign/case_card_image_2.png'
	},
	{
		id: 3,
		title: 'Мультибанкинг: автоматизация в финтехе',
		description: 'Сервис для автоматического распознавания банковских выписок',
		category: 'Финансы',
		image: '/images/portfolio/redesign/case_card_image_3.png'
	},
	{
		id: 4,
		title: 'B2B-платформа для оптовой торговли',
		description: 'Цифровая платформа, которая переводит ручные оптовые продажи в единый онлайн-канал с интеграцией 1С и CRM.',
		category: 'Ритейл',
		image: '/images/portfolio/redesign/case_card_image_4.png'
	},
	{
		id: 5,
		title: 'Личный кабинет в сельском хозяйстве для B2B',
		description: 'Разработка личного кабинета для агрегации заказов между производителем и фермерами',
		category: 'Промышленность',
		image: '/images/portfolio/redesign/case_card_image_5.png'
	},
	{
		id: 6,
		title: 'ИИ-решение для Kiwi Immigration на базе ChatGPT',
		description: 'Сервис для автоматической генерации сопроводительного письма с помощью ИИ в иммиграционную службу',
		category: 'Юридические услуги',
		image: '/images/portfolio/redesign/case_card_image_6.png'
	},
	// DISABLED:
	// {
	// 	id: 7,
	// 	title: 'Разработка личного кабинета',
	// 	description: 'Ведущий дистрибьютор семян и агросервиса в Восточной Сибири',
	// 	category: 'Промышленность',
	// 	image: '/images/portfolio/wheat-field.png'
	// },
	{
		id: 8,
		title: 'Дизайн-аудит маркетинговых каналов',
		description: 'Ведущий дистрибьютор семян и агросервиса в Восточной Сибири',
		category: 'Строительство',
		image: '/factory.png'
	},
	{
		id: 9,
		title: 'Разработка фирменного стиля',
		description: 'Кулинарная школа в Югорске',
		category: 'Другое',
		image: '/cookie.png'
	},
	// DISABLED:
	// {
	// 	id: 10,
	// 	title: 'Внедрение искусственного интеллекта (AI)',
	// 	description: 'Сервис для создания сопроводительного письма в иммиграционную службу',
	// 	category: 'Юридические услуги',
	// 	image: '/gpt.png'
	// },
	{
		id: 11,
		title: 'Цифровизация завода',
		description: 'Крупнейший производитель вездеходов в Восточной Сибири и на Дальнем Востоке',
		category: 'Промышленность',
		image: '/vehicle.png'
	},
	{
		id: 12,
		title: 'Цифровизация пищевого цеха',
		description: 'Крупнейший цех по поставке готовой продукции в регионе',
		category: 'Другое',
		image: '/donuts.png'
	},
    {
		id: 13,
		title: 'Цифровизация завода',
		description: 'Мукомольный завод в Сибири и на Дальнем Востоке',
		category: 'Промышленность',
		image: '/wheat.png'
	},
	{
		id: 14,
		title: 'Рекламная кампания',
		description: 'Эксперт малоэтажного строительства и лидера на рынке Иркутской области',
		category: 'Строительство',
		image: '/building.png'
	},
	{
		id: 15,
		title: 'Разработка сайта',
		description: '«Тулун-ТелеКом» – первый оператор связи на территории г. Тулуна',
		category: 'Другое',
		image: '/cifra.png'
	}
	// {
	// 	id: 16,
	// 	title: 'Продвижение цветочного бренда',
	// 	description: 'Money Roses – самая крупная сеть цветочных салонов в Восточной Сибири, которая насчитывает 21 салон',
	// 	category: 'Другое',
	// 	image: '/flowers.png'
	// }
]

export default function NewCasesContent() {
	const router = useRouter()
	const [activeCategory, setActiveCategory] = useState<string>('Все')
	const [windowWidth, setWindowWidth] = useState<number>(typeof window !== 'undefined' ? window.innerWidth : 1440)
	const [visibleCount, setVisibleCount] = useState<number>(12) // Начальное значение для десктопа

	const [emblaRef] = useEmblaCarousel({
		dragFree: true,
		align: 'start',
	})

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth)
		}

		handleResize()
		window.addEventListener('resize', handleResize)
		
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	// Определяем начальное количество в зависимости от размера экрана при первой загрузке
	useEffect(() => {
		if (windowWidth <= 767) {
			// Мобилка: начально 8
			setVisibleCount(8)
		} else {
			// Десктоп/планшет: начально 12
			setVisibleCount(12)
		}
	}, [windowWidth])

	// Сбрасываем счетчик при изменении категории
	useEffect(() => {
		if (windowWidth <= 767) {
			setVisibleCount(8)
		} else {
			setVisibleCount(12)
		}
	}, [activeCategory, windowWidth])

	const filteredCases = activeCategory === 'Все' 
		? cases 
		: cases.filter(caseItem => caseItem.category === activeCategory)

	const visibleCases = filteredCases.slice(0, visibleCount)
	const hasMore = filteredCases.length > visibleCount

	const handleLoadMore = () => {
		if (windowWidth <= 767) {
			// Мобилка: +4
			setVisibleCount(prev => prev + 4)
		} else {
			// Десктоп/планшет: +6
			setVisibleCount(prev => prev + 6)
		}
	}

	// Функция для обработки клика по карточке кейса
	const handleCaseClick = (caseId: number) => {
		const caseRoutes: Record<number, string> = {
			1: '/portfolio/treasury-automation',
			2: '/portfolio/materials-marketplace', 
			3: '/portfolio/multibanking',
			4: '/portfolio/partner-b2b',
			5: '/portfolio/lk-agro-b2b',
			6: '/portfolio/card-project',
			// DISABLED: 7: '/cases/lichnyj-kabinetdlja-agregacii-zakazov-v-selskohozjajstvennoj-otrasli',
			8: '/cases/bajkalskiy-gazobeton-smm-audit', 
			9: '/cases/shkola-vkusa-prjanosti-sladosti',
			// DISABLED: 10: '/cases/sozdanie-ai-reshenija-s-ispolzovaniem-chatgpt-dlja-kiwi-immigration',
			11: '/cases/cifrovaja-transformacija-zavoda-gusenichnoj-tehniki',
			12: '/cases/cifrovaja-transformacija-pishhevogo-proizvodstva',
            13: '/cases/cifrovizacija-krupnejshego-mukomolnogo-predprijatija-vostochnoj-sibiri',
			14: '/cases/tsk-brigada', 
			15: '/cases/tulun-telekom',
			16: '/cases/money-roses'
		}
		
		const route = caseRoutes[caseId]
		if (route) {
			router.push(route)
		}
	}

	// Calculate card width based on screen size
	const getCardSize = () => {
		if (windowWidth <= 1439) {
			return { width: 20.5, height: 24.625 }
		}
		return { width: 21.875, height: 26.25 }
	}

	const cardSize = getCardSize()

	return (
		<>
			<AnimatedSection animation="slideUp">
				<div className={styles.main__container}>
					<div className={styles.main__title}>
						<Typography variant='h1'>Наши работы</Typography>
					</div>
					<div className={styles.main__description}>
						<p>В нашем портфолио более 300 успешно завершённых кейсов. Мы разрабатываем ИТ-решения, которые отвечают требованиям стейкхолдеров и тенденциям на рынке.</p>
					</div>
				</div>
			</AnimatedSection>

			<AnimatedSection animation="slideUp">
				<div className={styles.categories}>
					<div className={styles.embla__viewport} ref={emblaRef}>
						<div className={styles.embla__container}>
							{categories.map((category) => (
								<div key={category} className={styles.embla__slide}>
									<button
										className={`${styles.categoryButton} ${activeCategory === category ? styles.categoryButtonActive : ''}`}
										onClick={() => setActiveCategory(category)}
									>
										{category}
									</button>
								</div>
							))}
						</div>
					</div>
				</div>
			</AnimatedSection>
            
			<AnimatedSection animation="slideUp">
				<div className={styles.portfolio}>
					<div className={styles.container}>
						<div className={styles.grid}>
                        {visibleCases.map((caseItem) => (
                            <AnimatedSection key={caseItem.id} animation="slideUp">
                                <div 
                                    className={styles.card}
                                    style={{
                                        width: `${cardSize.width}rem`
                                    }}
                                >
                                    <div 
                                        className={styles.imageContainer}
                                        style={{
                                            width: `${cardSize.width}rem`,
                                            height: `${cardSize.height}rem`,
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => handleCaseClick(caseItem.id)}
                                    >
                                        <div 
                                            className={styles.imageBackground}
                                            style={{
                                                backgroundImage: caseItem.image ? `url('${caseItem.image}')` : undefined,
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center',
                                            }}
                                        />
                                        <div className={styles.categoryBadge}>
                                            <span className={styles.categoryText}>
                                                {caseItem.category}
                                            </span>
                                        </div>
                                    </div>
                                    
                                    <div 
                                        className={styles.content}
                                        style={{
                                            width: `${cardSize.width}rem`
                                        }}
                                    >
                                        <div className={styles.textContainer}>
                                            <div className={styles.titleContainer}>
                                                <h3 className={styles.cardTitle}>
                                                    {caseItem.title}
                                                </h3>
                                            </div>
                                            <div className={styles.descriptionContainer}>
                                                <p className={styles.cardDescription}>
                                                    {caseItem.description}
                                                </p>
                                            </div>
                                        </div>
                                        
                                        <div className={styles.link}>
                                            <div 
                                                className={styles.linkContent}
                                                onClick={() => handleCaseClick(caseItem.id)}
                                            >
                                                <span className={styles.linkText}>Подробнее</span>
                                                <div className={styles.linkIcon}>
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="#f23b67" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AnimatedSection>
                        ))}
						</div>
						{hasMore && (
							<AnimatedSection animation="slideUp">
								<button className={styles.loadMoreButton} onClick={handleLoadMore}>
									<span className={styles.loadMoreText}>Показать ещё</span>
									<svg className={styles.loadMoreIcon} width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M0.94 0L4 3.05333L7.06 0L8 0.94L4 4.94L0 0.94L0.94 0Z" fill="white"/>
									</svg>
								</button>
							</AnimatedSection>
						)}
					</div>
				</div>
			</AnimatedSection>
            <AnimatedSection animation="fadeIn">
				<div className={styles.contactBlock}>
					<Contact />
				</div>
			</AnimatedSection>
		</>
	)
}

